
import { defineComponent } from "vue";

export default defineComponent({
  name: "ColorTheme",
  computed: {
    selectedTheme() {
      return this.$store.state.settings.theme;
    },
  },
  methods: {
    setTheme() {
      document.body.setAttribute("data-theme", this.selectedTheme);
    },
  },
  watch: {
    selectedTheme() {
      this.setTheme();
    },
  },
  mounted() {
    this.setTheme();
  },
});
